import React, { useContext } from "react";
import ChatContext from "./ChatContext";
import { hasElements } from "utils/arrays";
import Message from "./Message";
import MessageSender from "./MessageSender";
import { CircularProgress } from "components/common_components/Progress";

function Messages({ loading, retrying, retryingCountDown, loadMoreMessages, loadingMoreMessages }) {
    const { messages } = useContext(ChatContext);

    const renderLoading = () => {
        return (
            <div className="loading">
                <CircularProgress />
            </div>
        );
    };

    const renderRetrying = () => {
        return <div className="retrying">{`Retrying to fetch messages in ${retryingCountDown} seconds...`}</div>;
    };

    return (
        <section className="messages">
            {loading && renderLoading()}
            {retrying && renderRetrying()}
            {!loading && !retrying && (
                <>
                    <div className="messages-chat">
                        <div id="load-more" className="load-more">
                            {loadMoreMessages && (
                                <div onClick={loadMoreMessages}>{loadingMoreMessages ? <CircularProgress /> : "Load more"}</div>
                            )}
                        </div>
                        {hasElements(messages) &&
                            messages.map((message, index) => (
                                <Message
                                    key={message.index}
                                    message={message}
                                    isSameParticipant={index >= 1 && message.author === messages[index - 1].author}
                                />
                            ))}
                    </div>

                    <div className="footer-chat">
                        <MessageSender />
                    </div>
                </>
            )}
        </section>
    );
}

export default Messages;
